(function () {
  var STORAGE_KEY = "bwwFestivalActive";
  var VALID_VALUES = ["bww", "cocktail", "fringe", "food"];

  function isValidFestival(value) {
    return VALID_VALUES.indexOf(value) !== -1;
  }

  function getStoredFestival() {
    try {
      var value = window.localStorage.getItem(STORAGE_KEY);
      return isValidFestival(value) ? value : null;
    } catch (error) {
      return null;
    }
  }

  function setStoredFestival(value) {
    try {
      window.localStorage.setItem(STORAGE_KEY, value);
    } catch (error) {
      return;
    }
  }

  function updateStickyOffset(root) {
    var stickyHeader = document.querySelector(".header-section .sticky-header");
    var navBar = document.querySelector(".header-section .nav-bar");
    var sectionWrapper = root.closest(".festival-group-nav-section");
    var headerHeight = 0;

    if (stickyHeader) {
      headerHeight += stickyHeader.getBoundingClientRect().height;
    } else {
      var regularHeader = document.querySelector(".header-section .site-header");
      if (regularHeader) {
        var computed = window.getComputedStyle(regularHeader);
        if (computed.position === "fixed" || computed.position === "sticky") {
          headerHeight += regularHeader.getBoundingClientRect().height;
        }
      }
    }

    if (navBar) {
      var navComputed = window.getComputedStyle(navBar);
      if (navComputed.position === "fixed" || navComputed.position === "sticky") {
        headerHeight += navBar.getBoundingClientRect().height;
      }
    }

    var stickyOffset = headerHeight > 0 ? headerHeight + "px" : "0px";
    root.style.setProperty("--fg-sticky-top", stickyOffset);
    if (sectionWrapper) {
      sectionWrapper.style.setProperty("--fg-sticky-top", stickyOffset);
    }
  }

  function updateNavSpacer(root) {
    var sectionWrapper = root.closest(".festival-group-nav-section");
    if (!sectionWrapper) {
      return;
    }
    sectionWrapper.style.setProperty("--fg-nav-height", root.offsetHeight + "px");
  }

  function applyBwwLabelForState(root, isScrolled) {
    var bwwTab = root.querySelector("[data-bww-tab]");
    if (!bwwTab) {
      return;
    }
    var fullLabel = root.getAttribute("data-label-bww-full") || "Belfast Whiskey Week";
    var compactLabel = root.getAttribute("data-label-bww-compact") || "BWW";
    var bwwText = bwwTab.querySelector("[data-bww-label-text]");

    if (bwwText) {
      bwwText.textContent = isScrolled ? compactLabel : fullLabel;
      return;
    }

    bwwTab.textContent = isScrolled ? compactLabel : fullLabel;
  }

  function updateScrollState(root) {
    var compactDefault = root.getAttribute("data-compact-default") === "true";
    var isScrolled = compactDefault || window.scrollY > 16;
    root.classList.toggle("festival-group-nav--scrolled", isScrolled);
    applyBwwLabelForState(root, isScrolled);
    var activeTab = root.querySelector('[data-festival-tab][aria-selected="true"]');
    updateIndicator(root, activeTab);
  }

  function updateIndicator(root, activeTab) {
    var indicator = root.querySelector("[data-festival-indicator]");
    var tabList = root.querySelector(".festival-group-nav__tablist");

    if (!indicator || !tabList || !activeTab) {
      return;
    }

    var tabRect = activeTab.getBoundingClientRect();
    var listRect = tabList.getBoundingClientRect();
    var offset = tabRect.left - listRect.left + tabList.scrollLeft;

    indicator.style.width = tabRect.width + "px";
    indicator.style.transform = "translateX(" + offset + "px)";
  }

  function updateDescriptor(root, value) {
    var descriptor = root.querySelector("[data-festival-descriptor]");
    if (!descriptor) {
      return;
    }

    var descriptorValue = root.getAttribute("data-descriptor-" + value);
    if (descriptorValue) {
      descriptor.textContent = descriptorValue;
    }
  }

  function updateHeroLabels(root, value) {
    var label = root.getAttribute("data-label-" + value) || "";
    if (!label) {
      return;
    }

    var targets = document.querySelectorAll("[data-festival-hero-label]");
    targets.forEach(function (node) {
      node.textContent = label;
    });
  }

  function setActive(root, value, shouldPersist) {
    if (!isValidFestival(value)) {
      return;
    }

    var tabs = root.querySelectorAll("[data-festival-tab]");
    var activeTab = null;

    tabs.forEach(function (tab) {
      var isActive = tab.getAttribute("data-festival-value") === value;
      tab.setAttribute("aria-selected", isActive ? "true" : "false");
      tab.setAttribute("tabindex", isActive ? "0" : "-1");
      if (isActive) {
        activeTab = tab;
      }
    });

    root.setAttribute("data-active", value);
    document.dispatchEvent(
      new CustomEvent("bww:festival-change", {
        detail: {
          festival: value,
          sourceSectionId: root.getAttribute("data-section-id") || ""
        }
      })
    );
    updateDescriptor(root, value);
    updateHeroLabels(root, value);
    updateIndicator(root, activeTab);

    if (activeTab) {
      activeTab.scrollIntoView({
        behavior: root.classList.contains("festival-group-nav--reduced-motion") ? "auto" : "smooth",
        inline: "nearest",
        block: "nearest"
      });
    }

    if (shouldPersist) {
      setStoredFestival(value);
    }
  }

  function onKeyDown(root, event) {
    var current = event.target;
    if (!current || !current.matches("[data-festival-tab]")) {
      return;
    }

    var tabs = Array.prototype.slice.call(root.querySelectorAll("[data-festival-tab]"));
    var currentIndex = tabs.indexOf(current);

    if (event.key === "ArrowRight" || event.key === "Right") {
      event.preventDefault();
      var nextIndex = (currentIndex + 1) % tabs.length;
      tabs[nextIndex].focus();
      return;
    }

    if (event.key === "ArrowLeft" || event.key === "Left") {
      event.preventDefault();
      var prevIndex = (currentIndex - 1 + tabs.length) % tabs.length;
      tabs[prevIndex].focus();
      return;
    }

    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      setActive(root, current.getAttribute("data-festival-value"), true);
    }
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function typeLabel(type) {
    if (type === "products") return "Product";
    if (type === "pages") return "Page";
    if (type === "articles") return "Article";
    if (type === "collections") return "Collection";
    return "Result";
  }

  function closeSuggestions(input, suggestionsEl) {
    if (!suggestionsEl) return;
    suggestionsEl.hidden = true;
    suggestionsEl.innerHTML = "";
    input.setAttribute("aria-expanded", "false");
    input.removeAttribute("aria-activedescendant");
  }

  function initPredictiveSearch(root) {
    var searchForm = root.querySelector(".festival-group-nav__search");
    var input = root.querySelector(".festival-group-nav__search-input");
    var suggestionsEl = root.querySelector("[data-festival-search-suggestions]");
    if (!searchForm || !input || !suggestionsEl) {
      return;
    }

    var activeIndex = -1;
    var currentItems = [];
    var debounce = null;
    var controller = null;

    function renderItems(items) {
      currentItems = items || [];
      activeIndex = -1;

      if (!currentItems.length) {
        suggestionsEl.innerHTML = '<div class="festival-group-nav__suggestion-empty">No quick matches found</div>';
        suggestionsEl.hidden = false;
        input.setAttribute("aria-expanded", "true");
        return;
      }

      suggestionsEl.innerHTML = currentItems
        .map(function (item, index) {
          return (
            '<a class="festival-group-nav__suggestion" href="' +
            escapeHtml(item.url) +
            '" role="option" id="festival-suggestion-' +
            root.dataset.sectionId +
            "-" +
            index +
            '" aria-selected="false">' +
            "<span>" +
            escapeHtml(item.title) +
            "</span>" +
            '<span class="festival-group-nav__suggestion-type">' +
            escapeHtml(typeLabel(item.type)) +
            "</span>" +
            "</a>"
          );
        })
        .join("");

      suggestionsEl.hidden = false;
      input.setAttribute("aria-expanded", "true");
    }

    function setActiveItem(index) {
      var options = suggestionsEl.querySelectorAll(".festival-group-nav__suggestion");
      options.forEach(function (option, i) {
        var selected = i === index;
        option.setAttribute("aria-selected", selected ? "true" : "false");
        if (selected) {
          input.setAttribute("aria-activedescendant", option.id);
          option.scrollIntoView({ block: "nearest" });
        }
      });
    }

    function fetchSuggestions(query) {
      if (controller) {
        controller.abort();
      }
      controller = new AbortController();

      var endpoint =
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
          ? window.Shopify.routes.root
          : "/";

      var url =
        endpoint +
        "search/suggest.json?q=" +
        encodeURIComponent(query) +
        "&resources[type]=product,page,article,collection&resources[limit]=8";

      fetch(url, { signal: controller.signal })
        .then(function (response) {
          if (!response.ok) {
            throw new Error("Predictive search failed");
          }
          return response.json();
        })
        .then(function (data) {
          var results = (data && data.resources && data.resources.results) || {};
          var merged = [];

          ["products", "pages", "articles", "collections"].forEach(function (key) {
            var list = results[key] || [];
            list.forEach(function (item) {
              if (item && item.title && item.url) {
                merged.push({ title: item.title, url: item.url, type: key });
              }
            });
          });

          renderItems(merged.slice(0, 8));
        })
        .catch(function (error) {
          if (error && error.name === "AbortError") {
            return;
          }
          closeSuggestions(input, suggestionsEl);
        });
    }

    input.addEventListener("input", function () {
      var query = input.value.trim();
      clearTimeout(debounce);
      if (query.length < 2) {
        closeSuggestions(input, suggestionsEl);
        return;
      }

      debounce = setTimeout(function () {
        fetchSuggestions(query);
      }, 160);
    });

    input.addEventListener("keydown", function (event) {
      if (suggestionsEl.hidden) {
        return;
      }

      var options = suggestionsEl.querySelectorAll(".festival-group-nav__suggestion");
      if (!options.length) {
        return;
      }

      if (event.key === "ArrowDown") {
        event.preventDefault();
        activeIndex = (activeIndex + 1) % options.length;
        setActiveItem(activeIndex);
        return;
      }

      if (event.key === "ArrowUp") {
        event.preventDefault();
        activeIndex = (activeIndex - 1 + options.length) % options.length;
        setActiveItem(activeIndex);
        return;
      }

      if (event.key === "Escape") {
        event.preventDefault();
        closeSuggestions(input, suggestionsEl);
        return;
      }

      if (event.key === "Enter" && activeIndex >= 0 && options[activeIndex]) {
        event.preventDefault();
        window.location.href = options[activeIndex].getAttribute("href");
      }
    });

    document.addEventListener("click", function (event) {
      if (!root.contains(event.target)) {
        closeSuggestions(input, suggestionsEl);
      }
    });

    suggestionsEl.addEventListener("click", function () {
      closeSuggestions(input, suggestionsEl);
    });
  }

  function initFestivalGroupNav(root) {
    if (!root || root.dataset.festivalInitialized === "true") {
      return;
    }
    root.dataset.festivalInitialized = "true";

    var media = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (media.matches) {
      root.classList.add("festival-group-nav--reduced-motion");
    }

    if (typeof media.addEventListener === "function") {
      media.addEventListener("change", function (evt) {
        root.classList.toggle("festival-group-nav--reduced-motion", evt.matches);
      });
    } else if (typeof media.addListener === "function") {
      media.addListener(function (evt) {
        root.classList.toggle("festival-group-nav--reduced-motion", evt.matches);
      });
    }

    root.addEventListener("click", function (event) {
      var tab = event.target.closest("[data-festival-tab]");
      if (!tab || !root.contains(tab)) {
        return;
      }
      if (
        tab.getAttribute("data-festival-value") === "bww" &&
        root.getAttribute("data-is-home") !== "true"
      ) {
        var homeUrl = root.getAttribute("data-root-url") || "/";
        window.location.href = homeUrl;
        return;
      }
      setActive(root, tab.getAttribute("data-festival-value"), true);
      tab.focus();
    });

    root.addEventListener("keydown", function (event) {
      onKeyDown(root, event);
    });

    root.addEventListener("click", function (event) {
      var homeLink = event.target.closest("[data-festival-home-link]");
      if (!homeLink || !root.contains(homeLink)) {
        return;
      }

      setStoredFestival("bww");
      if (root.getAttribute("data-is-home") === "true") {
        event.preventDefault();
        setActive(root, "bww", true);
      }
    });

    var initialValue = getStoredFestival() || root.getAttribute("data-default-active") || "bww";
    if (!isValidFestival(initialValue)) {
      initialValue = "bww";
    }
    setActive(root, initialValue, false);
    updateStickyOffset(root);
    updateNavSpacer(root);
    root.classList.remove("festival-group-nav--scrolled");
    applyBwwLabelForState(root, false);
    window.requestAnimationFrame(function () {
      updateScrollState(root);
    });
    initPredictiveSearch(root);

    var resizeTimer = null;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var activeTab = root.querySelector('[data-festival-tab][aria-selected="true"]');
        updateIndicator(root, activeTab);
        updateStickyOffset(root);
        updateNavSpacer(root);
        updateScrollState(root);
      }, 80);
    });

    var scrollTicking = false;
    window.addEventListener(
      "scroll",
      function () {
        if (scrollTicking) {
          return;
        }
        scrollTicking = true;
        window.requestAnimationFrame(function () {
          updateScrollState(root);
          scrollTicking = false;
        });
      },
      { passive: true }
    );
  }

  function runInit() {
    var sections = document.querySelectorAll("[data-festival-group-nav]");
    sections.forEach(initFestivalGroupNav);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runInit);
  } else {
    runInit();
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (!event || !event.target) {
      return;
    }
    var root = event.target.querySelector("[data-festival-group-nav]");
    if (root) {
      initFestivalGroupNav(root);
    }
  });
})();
